var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'turnover-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      turnoverClass: '',
      searchCallbackFlag: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    turnovertypes () {
      return this.$store.getters.turnoverList
    },
    nextPage () {
      return this.$store.getters.turnoverListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.turnoverListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      var data = {'turnover_class': this.turnoverClass}
      this.$store.dispatch('TURNOVER_LIST_SEARCH', {url: url, data:data, callback: callback})
    },
    goTurnovertypeNew: function () {
      this.$router.push({ path: '/turnover_types/new', query: { type: this.$router.currentRoute.query.type}})
    },
    goTurnovertypeEdit: function(turnovertypeId) {
      this.$router.push({ path: '/turnover_types/' + turnovertypeId + '/edit'})
    },
    turnovertypeDelete: function(turnovertypeId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('TURNOVER_DELETE',  {id: turnovertypeId, callback: this.onSaved})
      }
    },
    half: function () {
      this.turnoverClass = utils.emHalf(this.turnoverClass)
    },
    onSaved: function (result) {
      this.$router.push('/turnover_types')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/turnovertype-list.js